import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ResetPasswordModel } from 'src/app/modules/resetpassword/model/resetPasswordModel';
import { environment } from 'src/environments/environment';
import { FormControl, Validators} from '@angular/forms';
import { ToastService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './resetpassword.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {
    constructor(private authService: AuthService, private router: Router, public _restAPI: RestAPIService,private toast: ToastService, private route: ActivatedRoute) {
        this._restAPI.loading  = false;
    }
    resetPasswordModel: ResetPasswordModel = new ResetPasswordModel();
    currentYear = new Date().getFullYear();
    passwordToken: string | null = null;
    newPassword = new FormControl('', [Validators.required]);
    confirmPassword = new FormControl('', [Validators.required]);

    ngOnInit(): void {
        this.passwordToken = this.route.snapshot.paramMap.get('passwordtoken') || '';
        if (!this.passwordToken) {
            this.toast.error('Invalid password reset token.');
            this.router.navigate(['/login']);
            return;
        }
    }

    resetPassword(): void{

        if(this.newPassword.invalid || this.confirmPassword.invalid){
            this.newPassword.markAsTouched();
            this.confirmPassword.markAsTouched();
            return;
        }

        if (this.resetPasswordModel.newPassword != this.resetPasswordModel.confirmPassword) {
            this.toast.error('Passwords do not match.');
            return;
        }
        
        this._restAPI.loading  = true;
        let postData = {
            newPassword: this.resetPasswordModel.newPassword,
            resetToken: this.passwordToken
        };

        this._restAPI.post<boolean>(environment.apiURL + 'api/usermanagement/resetpassword', postData).subscribe({
            next: (results) => {
                this._restAPI.loading  = false;
                this.toast.show('Your password has been changed successfully. Please login now.');
                this.router.navigate(['/login']);
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error);}
        });
    }

    hide = signal(true);
    hideConfirm = signal(true);

    clickEvent(event: MouseEvent) {
        this.hide.set(!this.hide());
        event.stopPropagation();
    }

    clickEventConfirm(event: MouseEvent) {
        this.hideConfirm.set(!this.hideConfirm());
        event.stopPropagation();
    }

    cancelAction(): void {
        this.router.navigate(['/login']);
    }
}